module.exports = __webpack_public_path__ + "files/a80a4aee89481268c6e8c693c62898ec.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/organization.png
// module id = 884
// module chunks = 60